import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Input } from 'components/fields'
import { Button, Col, Module, Row } from 'components/misc'
import { Form, Title } from 'components/layout'
import { FormattedMessage } from 'react-intl'
import { apiParticipants } from 'helpers/decorators/api'
import { form } from 'helpers/decorators'
import { MergeAccountsApprovalModal } from 'components/modals'
import { get } from 'lodash'
import styles from './merge-participant-accounts.styl'
import { connect } from 'react-redux'


@apiParticipants({ form: 'formMergeAccounts' })
@connect(
  state => ({
    mergeState: state.api.participants.merge
  }), {}
)
@form({
  form: 'formMergeAccounts',
  disableHook: true
})
class MergeParticipantAccounts extends Component {
  static propTypes = {
    mergeAccounts: PropTypes.func,
    mergeParticipantValues: PropTypes.object,
    modal: PropTypes.object,
    mergeState: PropTypes.object,
    notification: PropTypes.func,
    logError: PropTypes.func
  }

  handleSubmit (event) {
    this.props.modal('merge-accounts-approval-modal')
    event.preventDefault()
  }

  handleOnApprove () {
    const sourceParticipantId = get(this.props.mergeParticipantValues, 'sourceParticipantId')
    const targetParticipantId = get(this.props.mergeParticipantValues, 'targetParticipantId')

    this.props.mergeAccounts(sourceParticipantId, targetParticipantId).then(() => {
      this.props.modal(null)
    }).catch(this.handleError)
  }

  handleError = err => {
    this.props.logError(err)
    this.props.modal(null)
    if (err && err.body) {
      console.debug('error', err.body && err.body.userMessage)
      this.props.notification(err.body.userMessage || 'Error', 'error')
    }
  }

  render () {
    const sourceParticipantId = get(this.props.mergeParticipantValues, 'sourceParticipantId')
    const targetParticipantId = get(this.props.mergeParticipantValues, 'targetParticipantId')
    const { mergeState: { loading } = {} } = this.props

    return (
      <div className={styles.module_wrapper}>
        <Module verticallyNarrow primary>
          <div className={styles.wrapper}>
            <Row alignItems="center" gutters inner paddingTop>
              <Form>
                <Title h1>
                  <FormattedMessage
                    id="moduleTitle.accounts_merging"
                    defaultMessage="Account Merging (moving Awards)"
                  />
                </Title>
                <Col flex="0 1 200px" alignSelf="center">
                  <Input
                    label="Source Account ID (the one from which the award will be taken, without PN prefix)"
                    intlKey="label.merge_source_account"
                    name="sourceParticipantId"
                    type="number"
                    maxLength={8}
                  />
                </Col>
                <Input
                  label="Target Account ID (the one which will be used after the merging, without PN prefix)"
                  intlKey="label.merge_target_account"
                  name="targetParticipantId"
                  type="number"
                  maxLength={8}
                />

                <Button onClick={event => this.handleSubmit(event)}>
                  <FormattedMessage id="button.merge_accounts" defaultMessage="Merge Accounts" />
                </Button>

              </Form>
              <MergeAccountsApprovalModal
                modalId="merge-accounts-approval-modal"
                isLoading={loading}
                sourceParticipantId={sourceParticipantId}
                targetParticipantId={targetParticipantId}
                onApprove={() => this.handleOnApprove()}
              />
            </Row>
          </div>
        </Module>
      </div>
    )
  }
}

export default MergeParticipantAccounts
